/**
 * @description: 抹零设置2
 * @author: hwx
 */
<template>
	<div class="zero-manage-wrap">
		<div class="zero-list" v-show="showZero">
			<div class="row row-magin">
				<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addZero">新增抹零设置</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="zero_list"></table>
			</div>
		</div>
		<div class="zero-edit" v-show="showZeroEdit">
			<div class="page-tit">{{edit_tit}}</div>
			<p>注：如果勾选后买单订单，现付订单，账单时，会被多次抹零，账单是由多个订单组成的。</p>
			<div class="row rowpadding">
				<label class="col-md-1 ctr-label-left">适用门店：</label>
				<div class="col-md-4 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row rowpadding">
				<label class="col-md-1 ctr-label-left">抹零设置：</label>
				<div class="col-md-4">
					<input class="form-control input-readonly" placeholder="请选择抹零设置" v-model="edit_set" ref="edit_set"
						@click="openEditSet($event)" readonly>
					<span class="selection_clear" @click="clear_input('edit_set')">×</span>
					<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
				</div>
			</div>
			<div class="row rowpadding">
				<label class="col-md-1 ctr-label-left">区域设置：</label>
				<div class="col-md-4">
					<input class="form-control input-readonly" placeholder="请选择区域设置" v-model="edit_area" ref="edit_area"
						@click="openEditArea($event)" readonly>
					<span class="selection_clear" @click="clear_input('edit_area')">×</span>
					<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
				</div>
			</div>
			<div class="row rowpadding">
				<label class="col-md-1 ctr-label-left">类型设置：</label>
				<div class="col-md-4">
					<input class="form-control input-readonly" placeholder="请选择类型设置" v-model="edit_type" ref="edit_type"
						@click="openEditType($event)" readonly>
					<span class="selection_clear" @click="clear_input('edit_type')">×</span>
					<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editSub"
					ref="edit_sub">确定</button>
			</div>
		</div>
		<!-- 抹零弹窗 -->
		<div class="edit-set-wrap" ref="edit_set_wrap">
			<ul>
				<li>
					<input id="edit_set_item1" type="radio" name="edit_set_item1" v-model='edit_set_item' value="1">
					<label for="edit_set_item1">无</label>
				</li>
				<li>
					<input id="edit_set_item2" type="radio" name="edit_set_item2" v-model='edit_set_item' value="2">
					<label for="edit_set_item2">进位到“角”</label>
				</li>
				<li>
					<input id="edit_set_item3" type="radio" name="edit_set_item3" v-model='edit_set_item' value="3">
					<label for="edit_set_item3">进位到“1元”</label>
				</li>
				<li>
					<input id="edit_set_item4" type="radio" name="edit_set_item4" v-model='edit_set_item' value="4">
					<label for="edit_set_item4">进位到“10元”</label>
				</li>
				<li>
					<input id="edit_set_item5" type="radio" name="edit_set_item5" v-model='edit_set_item' value="5">
					<label for="edit_set_item5">进位到“100元”</label>
				</li>
				<li>
					<input id="edit_set_item6" type="radio" name="edit_set_item6" v-model='edit_set_item' value="6">
					<label for="edit_set_item6">四舍五入到“角”</label>
				</li>
				<li>
					<input id="edit_set_item7" type="radio" name="edit_set_item7" v-model='edit_set_item' value="7">
					<label for="edit_set_item7">四舍五入到“1元”</label>
				</li>
				<li>
					<input id="edit_set_item8" type="radio" name="edit_set_item8" v-model='edit_set_item' value="8">
					<label for="edit_set_item8">四舍五入到“10元”</label>
				</li>
				<li>
					<input id="edit_set_item9" type="radio" name="edit_set_item9" v-model='edit_set_item' value="9">
					<label for="edit_set_item9">四舍五入到“100元”</label>
				</li>
				<li>
					<input id="edit_set_item10" type="radio" name="edit_set_item10" v-model='edit_set_item' value="10">
					<label for="edit_set_item10">向下取整到角</label>
				</li>
				<li>
					<input id="edit_set_item11" type="radio" name="edit_set_item11" v-model='edit_set_item' value="11">
					<label for="edit_set_item11">向下取整到元</label>
				</li>
				<li>
					<input id="edit_set_item12" type="radio" name="edit_set_item12" v-model='edit_set_item' value="12">
					<label for="edit_set_item12">向下取整到10元</label>
				</li>
				<li>
					<input id="edit_set_item13" type="radio" name="edit_set_item13" v-model='edit_set_item' value="13">
					<label for="edit_set_item13">向下取整到100元</label>
				</li>
			</ul>
		</div>
		<!-- 区域弹窗 -->
		<div class="edit-area-wrap" ref="edit_area_wrap">
			<ul>
				<li>
					<input type="checkbox" id="editAreaAll" v-model='edit_area_all' @click="editAreaAll">
					<label for="editAreaAll">全部</label>
				</li>
				<li v-for="item in edit_area_arr">
					<input type="checkbox" :id="item.id" v-model="edit_area_item" :value="item.id">
					<label :for="item.id">{{item.name}}</label>
				</li>
			</ul>
		</div>
		<!-- 类型弹窗 -->
		<div class="edit-type-wrap" ref="edit_type_wrap">
			<ul>
				<li>
					<input type="checkbox" id="editTypeAll" v-model='edit_type_all' @click="editTypeAll">
					<label for="editTypeAll">全部</label>
				</li>
				<li v-for="item in edit_type_arr">
					<input type="checkbox" :id="item.id" v-model="edit_type_item" :value="item.id">
					<label :for="item.id">{{item.name}}</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				showZero: true,
				showZeroEdit: false,
				modify: '1',
				edit_tit: '新增抹零设置',
				edit_set: '',
				edit_set_item: '',
				edit_area: '',
				edit_area_all: false,
				c_edit_area_all: false,
				edit_area_arr: [],
				edit_area_item: [],
				edit_type: '',
				edit_type_all: false,
				c_edit_type_all: false,
				edit_type_arr: [{id: '1', name: '后买单订单'}, {id: '2', name: '现付订单'}, {id: '3', name: '账单'}],
				edit_type_item: [],
			}
		},
		watch: {
			edit_set: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_set).parent().find('.selection_clear').show();
					} else {
						$(this.$refs.edit_set).parent().find('.selection_clear').hide();
					}
				},
				deep: true
			},

			edit_area: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_area).parent().find('.selection_clear').show();
					} else {
						$(this.$refs.edit_area).parent().find('.selection_clear').hide();
					}
				},
				deep: true
			},
			edit_area_item: {
				handler: function(val, oldVal) {
					if(this.edit_area_item.length >= this.edit_area_arr.length) {
						this.edit_area_all = true;
						this.c_edit_area_all = true;
					} else {
						this.edit_area_all = false;
						this.c_edit_area_all = false;
					}
				},
				deep: true
			},

			edit_type: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_type).parent().find('.selection_clear').show();
					} else {
						$(this.$refs.edit_type).parent().find('.selection_clear').hide();
					}
				},
				deep: true
			},
			edit_type_item: {
				handler: function (val, oldVal) {
					if(this.edit_type_item.length >= this.edit_type_arr.length) {
						this.edit_type_all = true;
						this.c_edit_type_all = true;
					} else {
						this.edit_type_all = false;
						this.c_edit_type_all = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.initTable();
		},
		methods: {
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.zero_list).bootstrapTable("destroy");
				$(_this.$refs.zero_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "index",
						title: "行号",
						width: "5%",
						valign: "middle",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "shop_name",
						title: "门店",
						width: "10%"
					}, {
						field: "room_area_names",
						title: "区域",
						width: "13%",
						formatter: function(value, row, index) {
							return row.room_area_names.join(',');
						}
					}, {
						field: "types_names",
						title: "类型",
						width: "10%",
						formatter: function(value, row, index) {
							return row.types_names.join(',');
						}
					}, {
						field: "small_change_type_name",
						title: "抹零设置",
						width: "10%"
					}, {
						title: "操作",
						width: "13%",
						events: {
							'click .edit': function(e, value, row) {
								_this.modify = '2';
								_this.edit_id = row.id;
								_this.edit_tit = '修改抹零设置';
								_this.getShopData();
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								$(_this.$refs.edit_shop).prop('disabled', true);
								_this.edit_set = row.small_change_type_name;
								_this.edit_set_item = row.small_change_type;
								_this.getShopBoxArea($(_this.$refs.edit_shop).val());
								_this.edit_area = row.room_area_names.join(',');
								_this.edit_area_item = row.room_area_ids;
								_this.edit_type = row.types_names.join(',');
								_this.edit_type_item = row.types;
								_this.showZero = false;
								_this.showZeroEdit = true;
							},
							'click .del': function(e, value, row) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delZero(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue edit">修改</span><span class="text-blue del">删除</span>';
						}
					}],
				});
			},
			// 表格数据
			getList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getSmallChangeList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击新增
			addZero: function() {
				let _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增抹零设置';
				$(_this.$refs.edit_shop).prop('disabled', false);
				$(_this.$refs.edit_shop).val('').trigger('change');
				_this.edit_set = '';
				_this.edit_set_item = '';
				_this.edit_area = '';
				_this.edit_area_item = [];
				_this.edit_type = '';
				_this.edit_type_item = [];
				_this.showZero = false;
				_this.showZeroEdit = true;
				_this.getShopData();
				_this.getShopBoxArea($(_this.$refs.edit_shop).val());
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							$(_this.$refs.edit_shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.edit_set = '';
								_this.edit_set_item = '';
								_this.getShopBoxArea(e.params.data.id);
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 清空选项
			clear_input: function(name) {
				if(name == "edit_set") {
					this.edit_set = '';
					this.edit_set_item = '';
				} else if(name == "edit_area") {
					this.edit_area = '';
					this.edit_area_item = [];
				} else if(name == "edit_type") {
					this.edit_type = '';
					this.edit_type_item = [];
				}
			},
			// 打开抹零选项
			openEditSet: function() {
				let _this = this;

				let c_edit_set_item = _this.edit_set_item;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['抹零设置', true],
					area: ['560px', ''],
					content: $(_this.$refs.edit_set_wrap),
					offset: '100px',
					cancel: function() {
						// 右上角关闭
						if(_this.edit_set != "") {
							_this.edit_set_item = c_edit_set_item;
							return;
						}
						_this.edit_set_item = '';
					}
				}, function() {
					if(_this.edit_set_item == '1') {
						_this.edit_set = '无';
					} else if(_this.edit_set_item == '2') {
						_this.edit_set = '进位到“角”';
					} else if(_this.edit_set_item == '3') {
						_this.edit_set = '进位到“1元”';
					} else if(_this.edit_set_item == '4') {
						_this.edit_set = '进位到“10元”';
					} else if(_this.edit_set_item == '5') {
						_this.edit_set = '进位到“100元”';
					} else if(_this.edit_set_item == '6') {
						_this.edit_set = '四舍五入到“角”';
					} else if(_this.edit_set_item == '7') {
						_this.edit_set = '四舍五入到“1元”';
					} else if(_this.edit_set_item == '8') {
						_this.edit_set = '四舍五入到“10元”';
					} else if(_this.edit_set_item == '9') {
						_this.edit_set = '四舍五入到“100元”';
					} else if(_this.edit_set_item == '10') {
						_this.edit_set = '向下取整到角';
					} else if(_this.edit_set_item == '11') {
						_this.edit_set = '向下取整到元';
					} else if(_this.edit_set_item == '12') {
						_this.edit_set = '向下取整到10元';
					} else if(_this.edit_set_item == '13') {
						_this.edit_set = '向下取整到100元';
					}
					layer.closeAll();
				}, function() {
					if(_this.edit_set != "") {
						_this.edit_set_item = c_edit_set_item;
						return;
					}
					_this.edit_set_item = '';
				});
			},
			// 获取门店下包厢区域
			getShopBoxArea: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getRoomArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.edit_area_arr = data.response.result;
							// _this.edit_area_item = '';
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 打开区域选项
			openEditArea: function() {
				let _this = this;

				let c_edit_area_item = _this.edit_area_item;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['区域设置', true],
					area: ['560px', '400px'],
					content: $(_this.$refs.edit_area_wrap),
					offset: '100px',
					cancel: function() {
						// 右上角关闭
						if(_this.edit_area != "") {
							_this.edit_area_item = c_edit_area_item;
							return;
						}
						_this.edit_area_item = [];
					}
				}, function() {
					let arr = [];
					_this.edit_area_arr.forEach(function(item) {
						_this.edit_area_item.forEach(function(item2) {
							if(item.id == item2) {
								arr.push(item.name);
							}
						});
					});
					_this.edit_area = arr.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_area != "") {
						_this.edit_area_item = c_edit_area_item;
						return;
					}
					_this.edit_area_item = [];
				});
			},
			// 全选
			editAreaAll: function() {
				let _this = this;

				_this.edit_area_all = _this.c_edit_area_all;
				if(!_this.edit_area_all) { // 实现全选
					_this.edit_area_item = [];
					_this.edit_area_arr.forEach(function(item) {
						_this.edit_area_item.push(item.id);
					});
					console.log(_this.edit_area_item);
				} else { // 实现反选
					_this.edit_area_item = [];
				}
			},
			// 打开类型选项
			openEditType: function() {
				let _this = this;

				let c_edit_type_item = _this.edit_type_item;
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['区域设置', true],
					area: ['560px', ''],
					content: $(_this.$refs.edit_type_wrap),
					offset: '100px',
					cancel: function() {
						// 右上角关闭
						if(_this.edit_type != "") {
							_this.edit_type_item = c_edit_type_item;
							return;
						}
						_this.edit_type_item = [];
					}
				}, function() {
					let arr = [];
					_this.edit_type_arr.forEach(function(item) {
						_this.edit_type_item.forEach(function(item2) {
							if(item.id == item2) {
								arr.push(item.name);
							}
						});
					});
					_this.edit_type = arr.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_type != "") {
						_this.edit_type_item = c_edit_type_item;
						return;
					}
					_this.edit_type_item = [];
				});
			},
			// 全选
			editTypeAll: function() {
				let _this = this;

				_this.edit_type_all = _this.c_edit_type_all;
				if(!_this.edit_type_all) { // 实现全选
					_this.edit_type_item = [];
					_this.edit_type_arr.forEach(function(item) {
						_this.edit_type_item.push(item.id);
					});
				} else { // 实现反选
					_this.edit_type_item = [];
				}
			},
			// 新增、修改
			editSub: function() {
				let _this = this;
				let datas,
					url = '';
				if(_this.modify == '1') {
					// 新增
					datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"shop_id": $(_this.$refs.edit_shop).val(),
								"small_change_type": _this.edit_set_item,
								"room_area_ids": _this.edit_area_item,
								"types": _this.edit_type_item
							}
						},
						"comment": ""
					};
					url = Vue.ctUrl + "Shop/addSmallChange";
				} else if(_this.modify == '2') {
					// 修改
					datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": _this.edit_id,
								"shop_id": $(_this.$refs.edit_shop).val(),
								"small_change_type": _this.edit_set_item,
								"room_area_ids": _this.edit_area_item,
								"types": _this.edit_type_item
							}
						},
						"comment": ""
					};
					url = Vue.ctUrl + "Shop/updateSmallChange";
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('操作成功');
							$(_this.$refs.zero_list).bootstrapTable("refresh");
							_this.showZero = true;
							_this.showZeroEdit = false;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						console.log(err);
						layer.msg("出错啦");
					}
				});
			},
			// 返回列表
			backList: function() {
				this.showZero = true;
				this.showZeroEdit = false;
			},
			// 删除
			delZero: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/delSmallChange",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							layer.msg('删除成功');
							$(_this.$refs.zero_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.sub-margin {
		margin: 0 0 0 30px;
	}
	.zero-manage-wrap {
		.zero-list {
			.row-magin {
				margin: 0 0 30px;
			}
		}
		.zero-edit {
			>p {
				color: #F00;
				margin: 10px 0 30px;
			}
		}
		.edit-set-wrap {
			display: none;
			padding: 30px 20px;
			font-size: 14px;
			ul {
				width: 33%;
				margin: 0 auto;
				li {
					margin: 0 0 15px;
				}
				label {
					margin: 0 0 0 6px;
				}
			}
		}
		.edit-area-wrap {
			display: none;
			padding: 30px 20px;
			font-size: 14px;
			ul {
				width: 23%;
				margin: 0 auto;
				li {
					margin: 0 0 15px;
				}
				label {
					margin: 0 0 0 6px;
				}
			}
		}
		.edit-type-wrap {
			display: none;
			padding: 30px 20px;
			font-size: 14px;
			ul {
				width: 23%;
				margin: 0 auto;
				li {
					margin: 0 0 15px;
				}
				label {
					margin: 0 0 0 6px;
				}
			}
		}
	}
</style>